module.exports = __webpack_public_path__ + "img/C1.d34b9282.png";